export const isDescendant = (el, parentId) => {
  if (el.id === parentId) return true;

  return el.parentNode && isDescendant(el.parentNode, parentId);
};
